// Import everything from vendors
import './vendors/_css-vars-ponyfill.js'; import './vendors/_cssrelpreload.js'; import './vendors/_noUiSlider.js'; import './vendors/_slick-slider.js'; import './vendors/_wNumb.js';

import 'bootstrap';
import 'nouislider/distribute/nouislider.min.js';
import 'slick-carousel/slick/slick.min.js';

// Components
import './components/alert';
import './components/dropdown';
import './components/modal';
// import './components/collapse';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js